import { Flex } from 'styled-system/jsx';
import Trash from '@/common/assets/icons/trashIcon.svg?react';
import View from '@/common/assets/icons/eyeIcon.svg?react';
import { FileOnChange } from '@/common/components/base/input/fileInput/FileInput.type.ts';
import createAttachment from '@/common/components/base/input/base/helpers/createAttachment.ts';
import { ChangeEvent } from 'react';
import Button from '@/common/components/base/button/Button.tsx';
import { useFormContext } from 'react-hook-form';

const uploadFileAttachment = ({
  onChange,
  onRemoveFile,
  hasUploadedFile,
  onViewFile,
  disabled,
}: {
  onChange: FileOnChange;
  onRemoveFile: () => void;
  hasUploadedFile: boolean;
  onViewFile: () => void;
  disabled: boolean;
}) => [
  createAttachment({
    shouldRender: !hasUploadedFile,
    element: (
      <UploadFileAttachmentElement disabled={disabled} onChange={onChange} />
    ),
    size: 'large',
  }),
  createAttachment({
    shouldRender: hasUploadedFile,
    element: (
      <FilePreviewElement onViewFile={onViewFile} onRemoveFile={onRemoveFile} />
    ),
  }),
];
export default uploadFileAttachment;

const UploadFileAttachmentElement = ({
  onChange,
  disabled,
}: {
  onChange: FileOnChange;
  disabled: boolean;
}) => {
  const { setError, clearErrors } = useFormContext();
  const fileInputOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    const size = file?.size ?? 0;
    if (file && file.type !== 'application/pdf') {
      return setError('resume', {
        message: 'قالب فایل بارگذاری شده باید PDF باشد.',
      });
    }
    if (file && size > 10 * 1024*1024) {
      return setError('resume', {
        message: 'حجم فایل بارگذاری شده بیشتر از 10 مگابایت است.',
      });
    }
    if (file && file.type === 'application/pdf') {
      onChange(file);
      clearErrors('resume');
    }
  };
  return (
    <Button type="button" size="small" color="success" disabled={disabled}>
      <label htmlFor="file">
        فراخوانی فایل
        <input
          onChange={fileInputOnChange}
          disabled={disabled}
          id="file"
          type="file"
          accept="application/pdf"
          hidden
        />
      </label>
    </Button>
  );
};

const FilePreviewElement = ({
  onRemoveFile,
  onViewFile,
}: {
  onRemoveFile: () => void;
  onViewFile: () => void;
}) => {
  return (
    <Flex justifyContent="space-between" width="70%">
      <Trash
        onClick={() => {
          onRemoveFile();
        }}
      />
      <View
        onClick={() => {
          onViewFile();
        }}
      />
    </Flex>
  );
};
